import { UseFormReturn } from 'react-hook-form'

import { CustomFormQuestion } from 'components/tools/CustomForm/types'

type Params = {
  formMethods: UseFormReturn<any>
  questions: CustomFormQuestion[]
}

export default function setSolicitacaoDeFeriasAGSUS_Rejeicao(params: Params): CustomFormQuestion[] {
  const { questions, formMethods } = params

  const { watch } = formMethods

  const titleForQuestion = Object.fromEntries(questions.map((q) => [q.title, q.slug]))

  const justificativaRejeicao = watch(`form_answers.${titleForQuestion['JUSTIFICATIVA REJEIÇÃO']}`)

  const filteredQuestions = questions.filter((question) => {
    //CTPS
    if (question.title == 'Justificativa') {
      if (justificativaRejeicao == 'Outro') {
        return true
      } else {
        return false
      }
    }

    return true
  })

  return filteredQuestions
}
